export default __webpack_public_path__ + "static/img1@2x-d068f74ca9c0649c980016f858bb5e17.jpg";